import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTE_HOME } from "../constants/commonConstants";

export default function PrivateRoute({ canActivate, isLoading, children }) {
  if (isLoading) return null; // features not yet fetched — hold, don't redirect
  return canActivate ? children : <Navigate to={ROUTE_HOME} replace />;
}
